// CSS
import './DirectoryInstance.css';
// React hooks
import { useState, useEffect } from 'react';
// Skybase hooks
import { API_BASE_URL } from '../../../config';
// External hooks/components
import { useAuth as useClerkAuth } from '@clerk/react';
// Media assets
import FolderIcon from '../../../assets/StandardIcons/FolderIcons/yellow-folder-icon.png';
import DocIcon from '../../../assets/StandardIcons/DocumentIcons/document-icon.png';


// =================
// DirectoryInstance – represnts the repeater Component used on the /directory Product page.
// =================
function DirectoryInstance({ 
    entity,     // JSON -> {entity.kind: String, entity.id: String}
 }){

    // init hooks
    const { getToken } = useClerkAuth();

    // =================
    // FETCH ENTITY JSON
    // =================
    const [entityJson, setEntityJson] = useState(null);
    // onChange ('entity') – immediately refresh JSON if 'entity' changes
    useEffect(() => {
        fetchEntityJson();
    }, [entity])
    // fetchEntityJson() – async. fn. that fetches the Postgres JSON data associated with this 'entity.id'
    async function fetchEntityJson() {
        // determine endpoint
        const url_endpoint = entity.kind === 'folder' ? 'folders' : 'documents';

        // Clerk JWT
        const token = await getToken();
        if (!token) { return }; // don't attempt fetch() request if JWT DNE

        // GET /<ENTITIES>/{id}
        const url = new URL(`${API_BASE_URL}/api/v1/${url_endpoint}/${entity.id}`);
        const res = await fetch(url,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        if (!res.ok) { throw new Error(`Unable to fetch() entity (ID: ${entity.id})`)};
        const entity_json = await res.json();

        // trigger re-render
        setEntityJson(entity_json);
    }

    // entityIcon – the HTML <img/> element to display for this entity.king
    const entityIcon = entity.kind === 'folder' ? <img  className='DirectoryInstance-folder-icon' src={FolderIcon} alt='Folder Icon.'/> : <img className='DirectoryInstance-document-icon' src={DocIcon} alt='Document Icon.'/> ;
    
    // JSX Component (Animated placeholder) – displayed until successful entity JSON is fetched
    if (!entityJson) {
        return (
            <div className='DirectoryInstance-animation-placeholder'></div>
        )
    }

    // JSX Component
    return(
        <div className='DirectoryInstance'>
            
            {/* Entity icon */}
            <div className='DirectoryInstance-icon-col'>{entityIcon}</div>

            {/* Metadata */}
            <div className='DirectoryInstance-metadata-col'>
                
                {/* Name */}
                <div className='DirectoryInstance-metadata-name'>{entityJson?.name}</div>

                {/* Updated at */}
                <div className='DirectoryInstance-metadata--last-modified-text'>{new Date(entityJson?.updated_at).toLocaleDateString("en-US", {month: "long", day: "numeric", year: "numeric" })}</div>
            </div>
        </div>
    );
};


// Export statement
export default DirectoryInstance;